import React from "react";
import {
	Input,
	InputDate,
	InputGroups,
	InputParentGroup,
	Switch,
} from "../../Helpers/Input/Input";
import PhoneInput from "react-phone-input-2";
import trans, { isRTL } from "../../../utils";
import { useSelector } from "react-redux";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";

export default function VehicleSetup({ addData }) {
	const inf = useSelector((state) => state.users.user);
	const deviceTypeOptions = [
		{
			label: trans("TRACKER"),
			value: "TRACKER",
		},
		{
			label: trans("MDVR"),
			value: "MDVR",
		},
	];
	console.log("addData values", addData.values);
	return (
		<div className="vehiclesetup mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("vehicle setup")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<InputSelect
						label={trans("Device Type")}
						id="deviceType"
						name="deviceType"
						formstyle="form-input"
						placeholder={trans("Device Type")}
						options={deviceTypeOptions}
						onBlur={addData.handleBlur}
						onChange={(value) => addData.setFieldValue("deviceType", value)}
						errors={addData.errors.deviceType}
						touched={addData.touched.deviceType}
						value={addData.values.deviceType}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("IMEI number")}
						type="text"
						placeholder={trans("IMEI")}
						id="imei"
						name="imei"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.imei}
						touched={addData.touched.imei}
						value={addData.values.imei || ""}
					/>
				</div>
				<div className="col-lg-6">
					<div
						className={`position-relative form-input ${
							addData.touched.simNumber &&
							addData.errors.simNumber &&
							"form-error"
						}`}
					>
						<label className="form-label">{trans("SIM Number")}</label>
						<div dir="ltr">
							<PhoneInput
								country={"eg"}
								id="simNumber"
								name="simNumber"
								onBlur={(value) => addData.setFieldTouched("simNumber", true)}
								onChange={(value) => addData.setFieldValue("simNumber", value)}
								value={addData.values.simNumber || ""}
								countryCodeEditable={true}
								enableSearch={true}
								disableSearchIcon
							/>
						</div>
						{addData.touched.simNumber && addData.errors.simNumber ? (
							<div className="validation">
								{trans(addData.errors.simNumber)}
							</div>
						) : null}
					</div>
				</div>

				<div className="col-lg-6">
					<Input
						title={trans("SIM Number Serial")}
						type="text"
						placeholder={trans("SIM Number Serial")}
						id="simNumberSerial"
						name="simNumberSerial"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.simNumberSerial}
						touched={addData.touched.simNumberSerial}
						value={addData.values.simNumberSerial || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={`${trans("Odometer")} (${
							inf.attributes.distanceUnit
								? trans(inf.attributes.distanceUnit)
								: trans("km")
						})`}
						type="text"
						placeholder={trans(inf.attributes?.distanceUnit || "km")}
						id="odometer"
						name="odometer"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.odometer}
						touched={addData.touched.odometer}
						value={addData.values.odometer || ""}
					/>
				</div>

				<div className="col-lg-6">
					<InputDate
						title={trans("Vehicle Expiration")}
						id="vehicleExpires"
						name="vehicleExpires"
						onBlur={(value) => addData.setFieldTouched("vehicleExpires", true)}
						onChange={(value) => addData.setFieldValue("vehicleExpires", value)}
						errors={addData.errors.vehicleExpires}
						touched={addData.touched.vehicleExpires}
						value={addData.values.vehicleExpires || ""}
					/>
				</div>
				<div className="col-lg-6">
					<div className="form-input">
						<div className="by-100 flex-between">
							<label className="form-label by-25">
								{trans("Liscense Expiration Reminder")}
							</label>
							<div className="y-15">
								<Switch
									id="licenseExpireReminder"
									name="licenseExpireReminder"
									onBlur={addData.handleBlur}
									onChange={addData.handleChange}
									value={addData.values.licenseExpireReminder || ""}
								/>
							</div>
						</div>
					</div>
				</div>
				{addData.values.licenseExpireReminder && (
					<div className="col-lg-6">
						<InputDate
							title={trans("License Expire")}
							id="licenseExpire"
							name="licenseExpire"
							onBlur={(value) => addData.setFieldTouched("licenseExpire", true)}
							onChange={(value) =>
								addData.setFieldValue("licenseExpire", value)
							}
							errors={addData.errors.licenseExpire}
							touched={addData.touched.licenseExpire}
							value={addData.values.licenseExpire || ""}
						/>
					</div>
				)}
				{/* <div className="col-lg-6">
					<InputParentGroup
						title={trans("Vehicle related to")}
						mode={true}
						id="parent"
						name="parent"
						formstyle="form-input"
						onBlur={(value) => addData.setFieldTouched("parent", true)}
						onChange={(value) => addData.setFieldValue("parent", value)}
						errors={addData.errors.parent}
						touched={addData.touched.parent}
						value={addData.values.parent || ""}
					/>
				</div> */}
				<div className="col-lg-6">
					<InputGroups
						title={trans("Linked Group")}
						type="text"
						placeholder={trans("Ex. Group 1")}
						formstyle="form-input"
						id="groupId"
						name="groupId"
						onBlur={(value) => addData.setFieldTouched("groupId", true)}
						onChange={(value) => addData.setFieldValue("groupId", value)}
						value={addData.values.groupId || ""}
					/>
				</div>
				{/** <div className="col-lg-6">
          <InputDriversGroup
            id="driverId"
            name="driverId"
            title="Driver"
            type="text"
            placeholder="Driver"
            formstyle="form-input"
            onBlur={addData.handleBlur}
            onChange={addData.handleChange}
            value={addData.values.driverId || ""}
          />
        </div>*/}
				<div className="col-lg-6">
					<div className="position-relative" dir="ltr">
						<Input
							title={trans("Idle time")}
							type="text"
							placeholder={trans("Minutes/s")}
							id="idleTime"
							name="idleTime"
							formstyle="form-input"
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.values.idleAlert ? addData.errors.idleTime : ""}
							touched={addData.values.idleAlert ? addData.touched.idleTime : ""}
							disabled={addData.values.idleAlert ? false : true}
							value={addData.values.idleAlert ? addData.values.idleTime : ""}
						/>
						<div
							className={`Input-switch ${
								isRTL ? "Input-switch-rtl" : "Input-switch-ltr"
							}`}
						>
							<Switch
								id="idleAlert"
								name="idleAlert"
								onBlur={addData.handleBlur}
								onChange={addData.handleChange}
								value={addData.values.idleAlert}
							/>
							<div>
								<span className="switch-alert-label">{trans("Alert")}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="flex-between">
				<div className="form-input">
					<label className="form-label">{trans("Vehicle condition")}</label>
					<div className="d-flex">
						<Switch
							id="archived"
							name="archived"
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							value={addData.values.archived}
						/>
						<span className="switch-archive-label">{trans("Archived")}</span>
					</div>
				</div>
			</div>
		</div>
	);
}
